<template>
  <div id="site_advanced_settings_form" v-if="site.article_generation">
    <form ref="article_generation">
      <div class="row">
        <h3>Article Title</h3>
        <p class="info">This allows us to grab the article title dynamically by selecting the element it resides in and the property the title is contained in.</p>
        <div class="field">
          <label>Article Title Selector</label>
          <input type="text" placeholder="meta[og:article-name]" class="mono" name="title_selector" v-bind:value="site.article_generation.title_selector" />
        </div>
        <div class="field">
          <label>Article Title Property</label>
          <input type="text" placeholder="content" class="mono" name="title_property" v-bind:value="site.article_generation.title_property" />
        </div>
      </div>
      <div class="row border-bottom">
        <h3>Article ID</h3>
        <p class="info">This allows us to grab the site generated ID of an article to perform lookups by instead of using a Portico ID. We assume this ID never changes, even when the article path or content changes.</p>
        <div class="field">
          <label>Article ID Selector</label>
          <input type="text" placeholder="article" class="mono" name="article_id_selector" v-bind:value="site.article_generation.article_id_selector" />
        </div>
        <div class="field">
          <label>Article ID Property</label>
          <input type="text" placeholder="data-article-id" class="mono" name="article_id_property" v-bind:value="site.article_generation.article_id_property" />
        </div>
      </div>

      <div class="row border-bottom">
        <h3>Article Price</h3>
        <p class="info">This allows us to grab the site generated ID of an article to perform lookups by instead of using a Portico ID. We assume this ID never changes, even when the article path or content changes.</p>
        <div class="field">
          <label>Article Price</label>
          <div class="editable mono currency" contenteditable="true" data-placeholder="$0.99" name="price" v-bind:value="site.article_generation.price" />
        </div>
      </div>

      <button type="button" class="shadow shadow--small" @click="submit('article_generation')">Update Article Settings</button>
    </form>
    <hr />
    <form ref="metadata">
      <div class="row border-bottom">
        <h3>Custom Paywall HTML</h3>
        <p class="info">This is HTML that will display at the top of the paywall instead of the default text. Please refrain from adding custom CSS or JavaScript to this.</p>
        <div class="field double">
          <label>Paywall HTML</label>
          <textarea placeholder="<h1>Custom HTML</h1>" name="paywall_custom_content" v-bind:value="site.metadata.paywall_custom_content" />
        </div>
      </div>

      <div class="row border-bottom">
        <h3>Custom Footer HTML</h3>
        <p class="info">This is HTML that will display in the footer instead of the default text. Please refrain from adding custom CSS or JavaScript to this. This <b>must</b> include a <code>#login</code>, <code>#signup</code>, and <code>#feedback</code> ID.</p>
        <div class="field double">
          <label>Footer HTML</label>
          <textarea placeholder="<h1>Custom HTML</h1>" name="footer_custom_content" v-bind:value="site.metadata.footer_custom_content" />
        </div>
      </div>

      <div class="row border-bottom">
        <h3>Custom Login HTML</h3>
        <p class="info">This is HTML that will display in the login page instead of the default text. Please refrain from adding custom CSS or JavaScript to this.</p>
        <div class="field double">
          <label>Login HTML</label>
          <textarea placeholder="<h1>Custom HTML</h1>" name="login_custom_content" v-bind:value="site.metadata.login_custom_content" />
        </div>
      </div>

      <div class="row border-bottom">
        <h3>Logo Image Link</h3>
        <p class="info">This is a link to the logo image that will display at the top of the paywall for the client's site. Please make sure that the images are coming from a fast CDN and are small.</p>
        <div class="field double">
          <label>Image Link</label>
          <input type="text" placeholder="https://example.com/assets/logo.png" name="logo_image_link" v-bind:value="site.metadata.logo_image_link" />
        </div>
      </div>

      <div class="row border-bottom">
        <h3>Webhooks</h3>
        <p class="info">This is a link to send data to when a user signs up to the publishers.</p>
        <div class="field">
          <label>Link</label>
          <input type="text" placeholder="https://client-site.com/send/to/here" name="webhook_link" v-bind:value="site.metadata.webhook_link" />
        </div>
        <div class="field">
          <label>Method</label>
          <input type="text" placeholder="GET" name="webhook_method" v-bind:value="site.metadata.webhook_method" />
        </div>
      </div>

      <button type="button" class="shadow shadow--small" @click="submit('metadata')">Update Paywall Settings</button>
    </form>
  </div>
</template>

<script>
import utils from "@/js/utils";
import request from "@/js/request";

const { api_path } = utils;

export default {
  name: `SiteAdvancedSettingsForm`,
  props: ["site"],
  methods: {
    async submit (type) {
      console.log(this.site, type, this.$refs);

      let form = this.$refs[type];

      if (form.checkValidity() === true) {
        const data = utils.getFormInput(form);
        const { organization } = await utils.generalInformation();

        let response = await request(`${api_path.pay}/organizations/me/sites/${this.site.public_key}/`, {
          headers: {
            Authorization: `Basic ${organization.auth_token}`,
          },
        }).put({
          [type]: data,
        });

        console.log(response);
      }
    }
  },
}
</script>

<style scoped>
#site_advanced_settings_form > form {
  width: 1200px;
}

form {
  padding: 20px 0;
}

form > div:first-of-type {
  padding-top: 0;
}

h3 {
  margin: 20px 0 0 0;
  text-transform: uppercase;
  opacity: 0.5;
  font-size: 1em;
}

p.info {
  margin: 10px 0 20px 0;
  opacity: 0.7;
  max-width: 500px;
  font-size: 0.8em;
}

.row h3 {
  margin: 0;
}

.row {
  margin: 0;
  padding: 0 0 40px;
  display: block;
}

hr {
  margin: 40px 0;
  border: none;
  border-bottom: 1px solid #ddd;
}

.row .field {
  display: inline-block;
  vertical-align: top;
}

.row .field {
  max-width: 300px;
}

.row .field.double {
  max-width: 600px;
}

textarea {
  padding: 5px;
  min-height: 150px;
}

button {
  margin: 0;
  max-width: 300px;
}

code {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 2px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/special/SiteAdvancedSettingsForm.vue